/* Shine & Style — the hero VS band.
 *
 * The two halves are video and nothing else. There is no
 * photograph underneath: the clip's own first frame is the resting
 * picture, painted by the #t=0.001 fragment on its src, so a half
 * looks like a still until something asks it to move.
 *
 * Pointer devices: it moves when the pointer arrives, and returns
 * to that first frame when it leaves.
 *
 * Touch: no pointer, so each clip plays once as it scrolls into
 * view.
 *
 * Either way it does not loop, and the last frame is held rather
 * than snapping back.
 */
(function () {
  'use strict';

  var band = document.querySelector('[data-vs]');
  if (!band) return;

  var canHover = window.matchMedia('(hover: hover)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(band.querySelectorAll('.ss-vs__half'), function (half) {
    var video = half.querySelector('.ss-vs__video');
    if (!video) return;

    function play() {
      var p = video.play();
      /* Autoplay refused. The first frame is already on screen and
         is a complete state on its own, so there is nothing to
         fall back to and nothing to report. */
      if (p && p.catch) p.catch(function () {});
    }

    /* Rewinding is what restores the resting picture, since that
       picture is frame zero of this same element. */
    function rewind() {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    }

    if (canHover) {
      half.addEventListener('mouseenter', function () {
        try { video.currentTime = 0; } catch (e) {}
        play();
      });
      half.addEventListener('mouseleave', rewind);

      /* The half is a link, so a keyboard will land on it. Same
         behaviour, so it is not a pointer-only feature. */
      half.addEventListener('focus', play);
      half.addEventListener('blur', rewind);

    } else if (!reduced) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(half);
            play();
          });
        }, { threshold: 0.4 });
        io.observe(half);
      } else {
        play();
      }
    }
  });
})();
